import gql from 'graphql-tag';

const INITIATE_CHAT = gql`
  mutation initiateChat($listingId: String!) {
    initiateChat(listingId: $listingId) {
      channelId
      members
    }
  }
`;

const setInitiateChat = client => variables =>
  client.mutate({
    mutation: INITIATE_CHAT,
    variables
  });

export { setInitiateChat };
